module.exports = __webpack_public_path__ + "img/tree-of-life-logo-wit.32a7266f.png";